<template>
  <v-card outlined light class="rounded-md">
    <v-container style="background-color: #45e09e">
      <v-row>
        <v-col cols="auto" class="pa-6" align-self="center">
          <v-card-title
            primary-title
            style="text-align: left"
            class="pa-0"
            color="white"
          >
            <span
              style="
                font-family: Inter;
                color: white;
                font-size: 18px;
                line-height: 18px;
              "
            >
              <v-icon small color="white" style="margin-top: -3px"
                >mdi-cloud-outline</v-icon
              >
              Available APIs
            </span>
          </v-card-title>
        </v-col>
      </v-row>
    </v-container>
    <v-col class="pa-6 py-4">
      <endpoint-metric
        v-for="endpoint in advertisedEndpoints"
        :key="endpoint.key"
        :url="endpoint.url"
        :alert="endpoint.alert"
        :status="endpoint.status"
        :node="node"
        @value-copied="handleValueCopied"
      />
      <div
        v-if="advertisedEndpoints.length === 0"
        class="text-center grey--text"
      >
        No advertised endpoints available
      </div>
    </v-col>
    <v-snackbar v-model="showToast" :timeout="2000" bottom>
      {{ toastMessage }}
    </v-snackbar>
  </v-card>
</template>

<script>
import EndpointMetric from './EndpointMetric.vue';
import { isEndpointMetric } from '../../services/metricsCategorisation';

export default {
  components: {
    EndpointMetric,
  },
  props: {
    node: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showToast: false,
      toastMessage: '',
    };
  },
  computed: {
    supportedApisAdvertised() {
      const metricsDict = this.$store.state.metrics.metricsDict;
      const alerts = this.node?.alerts ?? [];

      const supportedApisAlert = alerts.find((alert) => {
        const metric = metricsDict[alert.metric];
        return (
          metric?.Module === 'Node' &&
          metric?.Name === 'Supported_Apis_Advertised'
        );
      });

      if (!supportedApisAlert) return [];

      const value = this.$store.state.metrics.metric[supportedApisAlert.id];
      return value ? value.split(', ') : [];
    },
    endpointAlerts() {
      const metricsDict = this.$store.state.metrics.metricsDict;
      const alerts = this.node?.alerts ?? [];

      return alerts
        .map((alert) => {
          const metric = metricsDict[alert.metric];
          return {
            ...alert,
            metric,
            key: `${metric.Module}${metric.Name}${alert.url ?? ''}`,
          };
        })
        .filter((alert) =>
          isEndpointMetric(alert.metric.Module, alert.metric.Name)
        );
    },
    monitoredEndpointUrls() {
      // Get a set of all monitored endpoint URLs
      const monitoredUrls = new Set();
      this.endpointAlerts.forEach((alert) => {
        if (alert.url) {
          monitoredUrls.add(alert.url);
        }
      });
      return monitoredUrls;
    },
    advertisedEndpoints() {
      // Create a list of advertised endpoints that aren't being monitored
      const endpoints = [];

      this.supportedApisAdvertised.forEach((api) => {
        if (!this.monitoredEndpointUrls.has(api)) {
          endpoints.push({
            url: api,
            alert: null,
            status: 'advertised',
            key: `advertised-${api}`,
          });
        }
      });

      return endpoints;
    },
  },
  methods: {
    handleValueCopied(message) {
      this.toastMessage = message;
      this.showToast = true;
    },
  },
};
</script>
